<a href="javascript:void(0);" tabindex="1" (click)="goToMainContent()" class="sr-only sr-only-focusable" id="skip"
  data-linktype="anchor">Skip to main content</a>
<gn-mobile-nav [feedbackSSOId]="feedbackSSOId" [primaryNavs]="primaryNavs" [globalLinks]="globalLinks" [homeUrl]="homeUrl" [alertsUrl]="alertsUrl" [registerUrl]="registerUrl"
  [appSettings]="appSettings" [accountLinks]="accountLinks" [userName]="userName" [domain]="domain" ></gn-mobile-nav>
<gn-global-link [feedbackSSOId]="feedbackSSOId" [globalLinks]="globalLinks"></gn-global-link>
<div class="nav-open-level-two" [ngClass]="{'secondary-padding': hideSecClass}" id="site-canvas">
  <header class="pru-header" role="banner">
    <div id="site-overlay"></div>
    <div class="toprow">
      <div class="container container-lg">
        <div class="nav-wrapper d-flex flex-nowrap align-items justify-content">
          <gn-mobile-menu *ngIf="showMobileHamburgerMenu"></gn-mobile-menu>
          <gn-pru-logo data-qa="gn-pru-logo" [logoSrc]="logoSrc" [homeUrl]="homeUrl"></gn-pru-logo>
          <gn-primary-nav data-qa="gn-primary-navs" [primaryNavs]="primaryNavs"></gn-primary-nav>
          <gn-mobile-action [appSettings]="appSettings" [logoutFn]="logoutFn" [loginUrl]="loginUrl"></gn-mobile-action>
          <!-- toprow-right start-->
          <div class="toprow-right">

            <div id="header-guest" class="header-guest" *ngIf="appSettings.showSignup || appSettings.showLogin">
              <gn-sign-up-link *ngIf="appSettings.showSignup" [registerUrl]="registerUrl"></gn-sign-up-link>
              <gn-login-link *ngIf="appSettings.showLogin" [loginUrl]="loginUrl"></gn-login-link>
            </div>

            <div id="header-account" class="header-account" *ngIf="appSettings.showAccount || appSettings.showLogout">
              <gn-header-account *ngIf="appSettings.showAccount" [userName]="userName" [accountLinks]="accountLinks"
                [domain]="domain" [alertsUrl]="alertsUrl"></gn-header-account>
              <gn-logout-link data-qa="gn-logout-link" *ngIf="appSettings.showLogout" [logoutFn]="logoutFn"></gn-logout-link>
            </div>

          </div>
          <!-- toprow-right End-->
        </div>
        <!-- nav wrapper -->
      </div>
      <!-- container -->
    </div>
    <!-- toprow -->
  </header>
</div>
